import { Carousel } from './carousel/carousel'
import styles from './vehicles-in-stock.module.css'
import sharedStyles from '../../landing-feature-store-page.module.css'
import type { Vehicle } from '@cinch-nx/shared-types'

import { StoreCtaButton } from '../cta-button'
import { generateStoreNameWithType } from '@cinch-nx/landing-ui-shared'

export interface VehiclesInStockProps {
  slug: string
  vehicles: Vehicle[]
}
export const VehiclesInStock = ({ slug, vehicles }: VehiclesInStockProps) => {
  const storeNameWithType = generateStoreNameWithType(slug)

  return (
    <section className={styles.root}>
      <h2
        className={sharedStyles.heading}
      >{`Cars in stock at ${storeNameWithType}`}</h2>
      <Carousel carouselName="vehicles-in-stock-carousel" vehicles={vehicles} />

      <div className={styles.buttonWrapper}>
        <StoreCtaButton
          slug={slug}
          trackEventTitle={'cars in stock at cinch store'}
        />
      </div>
    </section>
  )
}
